export default {"src":"/_next/static/media/area.ce178ae1.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};